import ngoProfileService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    working: false,
    drivers: [],
    driversLoading: false,
    driversWorking: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    driversLoading(state) {
      return state.driversLoading;
    },
    driversWorking(state) {
      return state.driversWorking;
    },
    working(state) {
      return state.working;
    },
    drivers(state) {
      return state.drivers;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setDriversLoading(state, payload) {
      state.driversLoading = payload;
    },
    setDriversWorking(state, payload) {
      state.driversWorking = payload;
    },
    setDrivers(state, payload) {
      state.drivers = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
  },
  actions: {
    async editAccount({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await ngoProfileService.updateBankAccount(payload);
        dispatch("handleResponse", res);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async addAccount({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await ngoProfileService.addBankAccount(payload);
        dispatch("handleResponse", res);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async addDriver({ commit, dispatch }, payload) {
      commit("setDriversWorking", true);
      try {
        const res = await ngoProfileService.addDriver(payload);
        dispatch("handleResponse", res);
        dispatch("fetchDrivers", payload.bank_account_id);
      } catch (err) {
      } finally {
        commit("setDriversWorking", false);
      }
    },
    async editDriver({ commit, dispatch }, payload) {
      commit("setDriversWorking", true);
      try {
        const res = await ngoProfileService.updateDriver(payload);
        dispatch("handleResponse", res);
      } catch (err) {
      } finally {
        commit("setDriversWorking", false);
      }
    },
    async fetchDrivers({ commit }, id) {
      commit("setDriversLoading", true);
      try {
        const data = await ngoProfileService.fetchDrivers(id);
        commit("setDrivers", data.data);
      } catch (err) {
      } finally {
        commit("setDriversLoading", false);
      }
    },
    async deleteAccount({ commit, dispatch }, id) {
      commit("setLoading", true);
      try {
        const res = await ngoProfileService.deleteBankAccount(id);
        dispatch("handleResponse", res);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async deleteDriver({ commit, dispatch }, id) {
      commit("setDriversLoading", true);
      try {
        const res = await ngoProfileService.deleteDriver(id);
        dispatch("handleResponse", res);
      } catch (err) {
      } finally {
        commit("setDriversLoading", false);
      }
    },
    handleResponse({ commit, dispatch }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",

            variant: "danger",
          },
        });
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
